// @ts-nocheck

(() => {
  "use strict";

  const EL = (globalThis.EspacioLaserV2 =
    globalThis.EspacioLaserV2 || {});

  class EngravingState {
    constructor(initialState = {}) {
      this.data = {
        content: {
          type: initialState.content?.type || "text",
          text: initialState.content?.text || "",
          lines: initialState.content?.lines || [],
          icon: initialState.content?.icon || null,
        },

        transform: {
          x: Number(initialState.transform?.x) || 0,
          y: Number(initialState.transform?.y) || 0,
          rotation:
            Number(initialState.transform?.rotation) || 0,
          scale:
            Number(initialState.transform?.scale) || 1,
        },

        appearance: {
          font:
            initialState.appearance?.font || "default",
          side:
            initialState.appearance?.side || "front",
          alignment:
            initialState.appearance?.alignment || "center",
        },

        constraints: {
          keepInsideBounds:
            initialState.constraints?.keepInsideBounds !== false,
        },

        ui: {
          selected: false,
          dragging: false,
          rotating: false,
          scaling: false,
          expanded: false,
          ...(initialState.ui || {}),
        },
      };

      this.listeners = new Set();
    }

    get content() {
      return this.data.content;
    }

    get transform() {
      return this.data.transform;
    }

    get appearance() {
      return this.data.appearance;
    }

    get constraints() {
      return this.data.constraints;
    }

    get ui() {
      return this.data.ui;
    }

    subscribe(listener) {
      if (typeof listener !== "function") {
        return () => {};
      }

      this.listeners.add(listener);

      return () => {
        this.listeners.delete(listener);
      };
    }

    notify(change = {}) {
      this.listeners.forEach((listener) => {
        listener(this, change);
      });
    }

    setText(text) {
      this.data.content.text =
        typeof text === "string" ? text : "";

      this.notify({
        type: "content:text",
        value: this.data.content.text,
      });
    }

    setPosition(x, y) {
      this.data.transform.x = Number(x) || 0;
      this.data.transform.y = Number(y) || 0;

      this.notify({
        type: "transform:position",
      });
    }

    setRotation(rotation) {
      this.data.transform.rotation =
        Number(rotation) || 0;

      this.notify({
        type: "transform:rotation",
      });
    }

    setScale(scale) {
      const value = Number(scale) || 1;

      this.data.transform.scale = Math.min(
        3,
        Math.max(0.35, value)
      );

      this.notify({
        type: "transform:scale",
      });
    }

    setUI(key, value) {
      if (!(key in this.data.ui)) return;

      this.data.ui[key] = Boolean(value);

      this.notify({
        type: `ui:${key}`,
      });
    }

    resetTransform() {
      this.data.transform.x = 0;
      this.data.transform.y = 0;
      this.data.transform.rotation = 0;
      this.data.transform.scale = 1;

      this.notify({
        type: "transform:reset",
      });
    }

    toJSON() {
      return JSON.parse(
        JSON.stringify(this.data)
      );
    }
  }

  EL.EngravingState = EngravingState;
})();